import { ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

const FORMULA = ["Healthcare Business", "Healthcare Knowledge", "Healthcare Networking"];

export const WhoWeAre = () => (
  <section id="about" className="relative overflow-hidden bg-[#EAF3F8] py-24 sm:py-32">
    <div className="pointer-events-none absolute -left-40 top-1/3 h-[420px] w-[420px] rounded-full bg-[#5FA832]/5 blur-[120px]" />
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-7">
        <Reveal>
          <SectionTag index="02" label="Who We Are" />
          <h2 className="font-display mt-6 text-2xl font-bold tracking-tight text-[#0B3C5C] sm:text-3xl lg:text-4xl">
            Building Better Connections Across Healthcare
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-7 max-w-2xl text-base leading-relaxed text-[#33586F] sm:text-lg">
            Healthcare is more than hospitals and treatment. It is an ecosystem of people,
            institutions, processes, professionals, insurance stakeholders and patients
            working together.
          </p>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#4A6B82]">
            <span className="font-semibold text-[#0B3C5C]">Healthcare Solutions</span> is being
            developed as a professional healthcare-sector solutions and knowledge platform
            focused on creating better coordination, awareness and opportunities across this
            ecosystem.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {FORMULA.map((f, i) => (
              <span key={f} className="flex items-center gap-3">
                <span className="rounded-full border border-teal-500/30 bg-[#5FA832]/10 px-4 py-2 text-xs font-semibold text-[#5FA832]">
                  {f}
                </span>
                {i < FORMULA.length - 1 && <span className="font-display text-lg text-amber-500">+</span>}
              </span>
            ))}
          </div>
          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-[#4A6B82]">
            We work towards creating practical solutions for healthcare institutions while
            making healthcare-related information more accessible and understandable for the
            wider public.
          </p>
          <a
            href="#ecosystem"
            data-testid="about-cta-know-more"
            className="group mt-8 inline-flex items-center gap-2 text-sm font-bold text-[#4C8F2F] transition-colors hover:text-[#5FA832]"
          >
            Know More About Us
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="lg:col-span-5">
        <div className="spotlight-frame relative">
          <div className="overflow-hidden rounded-[2rem] border border-[#0B3C5C]/15 shadow-2xl shadow-black/40">
            <img
              src={IMAGES.consultingMeeting}
              alt="Healthcare consulting meeting"
              className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
            />
          </div>
          <div className="font-mono-x mt-4 flex items-center justify-between text-[10px] uppercase tracking-[0.25em] text-[#6B8AA0]">
            <span>Ecosystem First</span>
            <span className="text-teal-500">Since Day One</span>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
